import { render } from "./NoticeListPage.vue?vue&type=template&id=298b0298"
import script from "./NoticeListPage.vue?vue&type=script&lang=js"
export * from "./NoticeListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__